import React from "react";
import { withTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';

import { fetchLessonQuestions } from "../actions";
import QuestionView from "../../Admin/Question/View/QuestionView";
import ShowQuestionModal from "./ExamView/ShowQuestionModal";

class LessonQuestionsList extends React.Component {

    state = {
        isFirstQuestions: true,
        isFirst: true,
        showQuestionModal: false,
        question: null,
        index: 1,
        showInfoPageModal: false,
        SelectedQuestions: [],
        focusedSkillId: 'ALL',
        searchQuery: '',
        collapsedGroups: {}
    };

    static getDerivedStateFromProps(props, state) {
        if (props.SelectedQuestions && props.SelectedQuestions.length > 0 && state.isFirst) {
            state.isFirst = false;
            state.isFirstQuestions = false;
            state.SelectedQuestions = props.SelectedQuestions;
            if (props.setSelect) {
                props.setSelect(state.SelectedQuestions);
            }
        } else if (props.lessonQuestions?.Questions && props.lessonQuestions?.Questions.length > 0 && state.isFirstQuestions) {
            state.isFirstQuestions = false;
            state.isFirst = false;
            state.SelectedQuestions = props.lessonQuestions?.Questions.map(item => item.Id);
            if (props.setSelect) {
                props.setSelect(state.SelectedQuestions);
            }
        }
        return state;
    }

    componentDidMount() {
        if (this.props.lessonQuestions?.LessonId !== this.props.LessonId) {
            this.props.fetchLessonQuestions(this.props.LessonId);
        }
    }

    showQuestionModal = (question, index) => {
        this.setState({
            showQuestionModal: true,
            question,
            index
        });
    };

    showInfoPageModal = () => {
        this.setState({
            showInfoPageModal: true
        });
    };

    handleClose = () => {
        this.setState({
            showQuestionModal: false,
            showInfoPageModal: false,
            question: null,
            index: 1
        });
    };

    renderInfoPageQuestionView = () => {
        const questions = this.props.lessonQuestions?.Questions || [];
        return questions.filter(p => p.Position === true).map((question, index) => (
            <QuestionView
                question={question}
                answers={question.Answers}
                key={question.Id}
                index={index + 1}
                showResult={false}
                onEdit={true}
                solveButton={false}
            />
        ));
    };

    renderQuestionView = () => {
        return (
            <QuestionView
                question={this.state.question}
                answers={this.state.question?.Answers}
                key={this.state.question?.Id}
                index={this.state.index}
                showResult={false}
                onEdit={true}
                solveButton={false}
            />
        );
    };

    SelectQuestion = Id => {
        let SelectedQuestions = [...this.state.SelectedQuestions];
        if (!SelectedQuestions.includes(Id)) {
            SelectedQuestions.push(Id);
        }
        this.setState({ SelectedQuestions });
        if (this.props.setSelect) {
            this.props.setSelect(SelectedQuestions);
        }
    };

    DeselectQuestion = Id => {
        let SelectedQuestions = this.state.SelectedQuestions.filter(ele => ele !== Id);
        this.setState({ SelectedQuestions });
        if (this.props.setSelect) {
            this.props.setSelect(SelectedQuestions);
        }
    };

    selectAllQuestions = () => {
        const allQuestions = (this.props.lessonQuestions?.Questions || []).filter(p => p.Position === false).map(q => q.Id);
        this.setState({ SelectedQuestions: allQuestions });
        if (this.props.setSelect) {
            this.props.setSelect(allQuestions);
        }
    };

    deselectAllQuestions = () => {
        this.setState({ SelectedQuestions: [] });
        if (this.props.setSelect) {
            this.props.setSelect([]);
        }
    };

    toggleGroupCollapse = (groupId) => {
        this.setState(prev => ({
            collapsedGroups: {
                ...prev.collapsedGroups,
                [groupId]: !prev.collapsedGroups[groupId]
            }
        }));
    };

    getQuestionSkills = (question) => {
        if (!question) return [];
        if (question.Skills && Array.isArray(question.Skills) && question.Skills.length > 0) {
            return question.Skills.map(s => ({
                id: String(s.Id || s.SkillId || s.name || s.Name),
                name: s.Name || s.SkillName || s.name || 'مهارة',
                domain: s.DimensionName || s.DomainName || s.Domain?.Name || s.domain || '',
                dimensionComponent: s.DimensionComponentName || s.SubDomainName || '',
                subDomain: s.SubDomainName || ''
            }));
        }
        if (question.Skill) {
            return [{
                id: String(question.Skill.Id || question.Skill.SkillId || question.Skill.Name),
                name: question.Skill.Name || question.Skill.SkillName || 'مهارة',
                domain: question.Skill.DimensionName || question.Skill.DomainName || question.Skill.Domain?.Name || '',
                dimensionComponent: question.Skill.DimensionComponentName || question.Skill.SubDomainName || '',
                subDomain: question.Skill.SubDomainName || ''
            }];
        }
        if (question.Curr_QuestionSkills && Array.isArray(question.Curr_QuestionSkills)) {
            return question.Curr_QuestionSkills.map(qs => ({
                id: String(qs.Curr_Skills?.Id || qs.SkillId),
                name: qs.Curr_Skills?.SkillName || qs.Curr_Skills?.Name || 'مهارة',
                domain: qs.Curr_Skills?.Curr_DimensionsComponents?.Curr_Dimensions?.Name || qs.Curr_Skills?.Curr_Domains?.Name || '',
                dimensionComponent: qs.Curr_Skills?.Curr_DimensionsComponents?.Name || qs.Curr_Skills?.Curr_SubDomains?.Name || '',
                subDomain: qs.Curr_Skills?.Curr_SubDomains?.Name || ''
            }));
        }
        if (this.props.lesson?.Questions && Array.isArray(this.props.lesson.Questions)) {
            const matched = this.props.lesson.Questions.find(q => q.Id === question.Id);
            if (matched && matched.Skills && Array.isArray(matched.Skills) && matched.Skills.length > 0) {
                return matched.Skills.map(s => ({
                    id: String(s.Id || s.SkillId || s.Name),
                    name: s.Name || s.SkillName || 'مهارة',
                    domain: s.DimensionName || s.DomainName || s.Domain?.Name || '',
                    dimensionComponent: s.DimensionComponentName || s.SubDomainName || '',
                    subDomain: s.SubDomainName || ''
                }));
            }
        }
        if (this.props.lesson?.Skills && Array.isArray(this.props.lesson.Skills) && this.props.lesson.Skills.length > 0) {
            return this.props.lesson.Skills.map(s => ({
                id: String(s.Id || s.SkillId || s.Name || s.id),
                name: s.Name || s.SkillName || s.name || 'مهارة عامة',
                domain: s.DimensionName || s.DomainName || s.Domain?.Name || s.domain || '',
                dimensionComponent: s.DimensionComponentName || s.SubDomainName || '',
                subDomain: s.SubDomainName || ''
            }));
        }
        return [];
    };

    /**
     * Build the exact hierarchical skills tree matching LessonItem / LessonViewHelper:
     * 1. domainTree: DimensionName/DomainName -> DimensionComponentName -> Skills
     * 2. otherSkillsTree: DomainName -> SubDomainName -> Skills
     */
    buildHierarchicalSkillsTree = (questions = []) => {
        const { t, lesson } = this.props;
        const displaySkills = (lesson && Array.isArray(lesson.Skills) && lesson.Skills.length > 0)
            ? lesson.Skills
            : [];

        const domainMap = {};
        const otherSkillsDomainMap = {};

        // 1. Group strictly as in LessonItemContent.js using Set for deduplication
        displaySkills.forEach(s => {
            if (!s.SkillName) return;

            if (s.DimensionComponentName) {
                const domainName = s.DimensionName || s.DomainName || t("QuestionView.uncategorized") || "المجال العام";
                const compName = s.DimensionComponentName;

                if (!domainMap[domainName]) {
                    domainMap[domainName] = {};
                }
                if (!domainMap[domainName][compName]) {
                    domainMap[domainName][compName] = new Set();
                }
                domainMap[domainName][compName].add(s.SkillName);
            } else {
                const domainName = s.DomainName || t("OtherSkills") || "مهارات أخرى";
                const subDomainName = s.SubDomainName || "مهارات عامة";

                if (!otherSkillsDomainMap[domainName]) {
                    otherSkillsDomainMap[domainName] = {};
                }
                if (!otherSkillsDomainMap[domainName][subDomainName]) {
                    otherSkillsDomainMap[domainName][subDomainName] = new Set();
                }
                otherSkillsDomainMap[domainName][subDomainName].add(s.SkillName);
            }
        });

        // If lesson.Skills was not provided, fallback to question skills uniquely
        if (displaySkills.length === 0) {
            questions.forEach(q => {
                const qSkills = this.getQuestionSkills(q);
                qSkills.forEach(s => {
                    const skillName = s.name || s.SkillName;
                    if (!skillName) return;

                    if (s.dimensionComponent) {
                        const domainName = s.domain || t("QuestionView.uncategorized") || "المجال العام";
                        const compName = s.dimensionComponent;
                        if (!domainMap[domainName]) domainMap[domainName] = {};
                        if (!domainMap[domainName][compName]) domainMap[domainName][compName] = new Set();
                        domainMap[domainName][compName].add(skillName);
                    } else {
                        const domainName = s.domain || t("OtherSkills") || "مهارات أخرى";
                        const subDomainName = s.subDomain || "مهارات عامة";
                        if (!otherSkillsDomainMap[domainName]) otherSkillsDomainMap[domainName] = {};
                        if (!otherSkillsDomainMap[domainName][subDomainName]) otherSkillsDomainMap[domainName][subDomainName] = new Set();
                        otherSkillsDomainMap[domainName][subDomainName].add(skillName);
                    }
                });
            });
        }

        // Helper to find questions linked to this skill
        const getQuestionsForSkill = (skillName) => {
            return questions.filter(q => {
                if (lesson && Array.isArray(lesson.Skills)) {
                    const matched = lesson.Skills.some(ls =>
                        (ls.SkillName === skillName || ls.Name === skillName) &&
                        Number(ls.QuestionId) === Number(q.Id)
                    );
                    if (matched) return true;
                }
                const qSkills = this.getQuestionSkills(q);
                return qSkills.some(qs => (qs.name === skillName || qs.SkillName === skillName));
            });
        };

        const domainTree = Object.keys(domainMap).map((domainName, dIdx) => ({
            id: `domain-${dIdx}`,
            name: domainName,
            components: Object.keys(domainMap[domainName]).map((compName, cIdx) => ({
                id: `comp-${dIdx}-${cIdx}`,
                name: compName,
                skills: Array.from(domainMap[domainName][compName]).map((skillName, sIdx) => ({
                    id: `skill-${dIdx}-${cIdx}-${sIdx}`,
                    name: skillName,
                    domain: domainName,
                    comp: compName,
                    questions: getQuestionsForSkill(skillName)
                }))
            }))
        }));

        const otherSkillsTree = Object.keys(otherSkillsDomainMap).map((domainName, oIdx) => ({
            id: `other-domain-${oIdx}`,
            name: domainName,
            subDomains: Object.keys(otherSkillsDomainMap[domainName]).map((subDomainName, sIdx) => ({
                id: `other-sub-${oIdx}-${sIdx}`,
                name: subDomainName,
                skills: Array.from(otherSkillsDomainMap[domainName][subDomainName]).map((skillName, skIdx) => ({
                    id: `other-skill-${oIdx}-${sIdx}-${skIdx}`,
                    name: skillName,
                    domain: domainName,
                    comp: subDomainName,
                    questions: getQuestionsForSkill(skillName)
                }))
            }))
        }));

        return { domainTree, otherSkillsTree };
    };

    toggleSelectSkillQuestions = (skillQuestions = []) => {
        const questionIds = skillQuestions.map(q => q.Id);
        let currentSelected = [...this.state.SelectedQuestions];
        const isAllSkillQuestionsSelected = questionIds.length > 0 && questionIds.every(id => currentSelected.includes(id));

        if (isAllSkillQuestionsSelected) {
            currentSelected = currentSelected.filter(id => !questionIds.includes(id));
        } else {
            questionIds.forEach(id => {
                if (!currentSelected.includes(id)) {
                    currentSelected.push(id);
                }
            });
        }

        this.setState({ SelectedQuestions: currentSelected });
        if (this.props.setSelect) {
            this.props.setSelect(currentSelected);
        }
    };

    toggleSelectGroupQuestions = (groupSkills = []) => {
        const allGroupQuestionIds = [];
        groupSkills.forEach(s => {
            (s.questions || []).forEach(q => {
                if (!allGroupQuestionIds.includes(q.Id)) {
                    allGroupQuestionIds.push(q.Id);
                }
            });
        });

        let currentSelected = [...this.state.SelectedQuestions];
        const isAllGroupSelected = allGroupQuestionIds.length > 0 && allGroupQuestionIds.every(id => currentSelected.includes(id));

        if (isAllGroupSelected) {
            currentSelected = currentSelected.filter(id => !allGroupQuestionIds.includes(id));
        } else {
            allGroupQuestionIds.forEach(id => {
                if (!currentSelected.includes(id)) {
                    currentSelected.push(id);
                }
            });
        }

        this.setState({ SelectedQuestions: currentSelected });
        if (this.props.setSelect) {
            this.props.setSelect(currentSelected);
        }
    };

    render() {
        const { t, lessonQuestions } = this.props;
        const { SelectedQuestions, focusedSkillId, searchQuery, collapsedGroups } = this.state;

        if (!lessonQuestions || !lessonQuestions.Questions || lessonQuestions.Questions.length === 0) {
            return (
                <div className="text-center py-5 text-muted">
                    <i className="fad fa-sync-alt fa-spin fa-2x mb-2 text-primary"></i>
                    <div>{t("Loading") || 'جارٍ تحميل أسئلة ومهارات الدرس...'}</div>
                </div>
            );
        }

        const allQuestions = lessonQuestions.Questions;
        const regularQuestions = allQuestions.filter(p => p.Position === false);

        const { domainTree, otherSkillsTree } = this.buildHierarchicalSkillsTree(regularQuestions);
        const isAllSelected = regularQuestions.length > 0 && regularQuestions.every(q => SelectedQuestions.includes(q.Id));

        const allSkillsFlatList = [
            ...domainTree.flatMap(d => d.components.flatMap(c => c.skills)),
            ...otherSkillsTree.flatMap(o => o.subDomains.flatMap(s => s.skills))
        ];
        const focusedSkillObj = focusedSkillId !== 'ALL' ? allSkillsFlatList.find(s => s.id === focusedSkillId) : null;
        const focusedSkillName = focusedSkillObj ? focusedSkillObj.name : '';

        // Filter questions based on focusedSkillId and search
        const filteredQuestions = regularQuestions.filter(q => {
            let matchesSkill = true;
            if (focusedSkillObj) {
                matchesSkill = focusedSkillObj.questions.some(item => item.Id === q.Id);
            }
            const matchesSearch = !searchQuery || (
                (q.Name && q.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (this.getQuestionSkills(q).some(s => s.name && s.name.toLowerCase().includes(searchQuery.toLowerCase())))
            );
            return matchesSkill && matchesSearch;
        });

        const renderSkillNode = (skill) => {
            const skillQuestionIds = skill.questions.map(q => q.Id);
            const selectedCount = skillQuestionIds.filter(id => SelectedQuestions.includes(id)).length;
            const isSkillAllSelected = skillQuestionIds.length > 0 && selectedCount === skillQuestionIds.length;
            const isSkillPartial = selectedCount > 0 && selectedCount < skillQuestionIds.length;
            const isFocused = focusedSkillId === skill.id;

            return (
                <div
                    key={`skill-node-${skill.id}`}
                    className={`skill-tree-item ${isFocused ? 'active-focused' : ''} ${isSkillAllSelected ? 'all-selected' : isSkillPartial ? 'partial-selected' : ''}`}
                    onClick={() => this.setState({ focusedSkillId: isFocused ? 'ALL' : skill.id })}
                    title={`انقر لعرض أسئلة مهارة: ${skill.name}`}
                    style={{ paddingRight: '18px' }}
                >
                    <div className="d-flex align-items-center flex-grow-1 ml-1">
                        {/* Checkbox toggles ALL questions of this skill */}
                        <input
                            type="checkbox"
                            className="ml-2"
                            checked={isSkillAllSelected}
                            onChange={() => this.toggleSelectSkillQuestions(skill.questions)}
                            onClick={(e) => e.stopPropagation()}
                            title={`تحديد أو إلغاء تحديد كافة أسئلة: ${skill.name}`}
                        />
                        <span className="small font-weight-bold text-dark text-truncate" style={{ maxWidth: '170px' }}>
                            {skill.name}
                        </span>
                    </div>

                    <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                        {isSkillPartial && (
                            <i className="fas fa-minus-square text-warning" style={{ fontSize: '0.75rem' }} title="مختار جزئياً"></i>
                        )}
                        <span
                            className={`badge ${isSkillAllSelected ? 'badge-success' : isSkillPartial ? 'badge-warning' : 'badge-light border text-muted'}`}
                            style={{ fontSize: '0.68rem', borderRadius: '10px' }}
                        >
                            {selectedCount}/{skillQuestionIds.length}
                        </span>
                    </div>
                </div>
            );
        };

        return (
            <div className="lesson-questions-custom-container">
                {/* 2-Column Split Layout */}
                <div className="questions-split-view">

                    {/* Right Column: شجرة المهارات المستهدفة (مطابقة تماماً لـ LessonItem) */}
                    <div className="skills-tree-sidebar shadow-2xs">
                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                            <span className="font-weight-bold text-dark" style={{ fontSize: '0.88rem' }}>
                                <i className="fas fa-sitemap text-primary ml-1"></i>
                                {t('Pages.Missions.SkillsTreeTitle') || 'شجرة المهارات المستهدفة'}
                            </span>
                            <span className="badge badge-light border text-primary font-weight-bold" style={{ fontSize: '0.75rem', borderRadius: '12px' }}>
                                {SelectedQuestions.length} / {regularQuestions.length} {t('QuestionsCount') || 'سؤال'}
                            </span>
                        </div>

                        {/* Quick Selection Helper Bar */}
                        <div className="d-flex justify-content-between align-items-center mb-2" style={{ gap: '6px' }}>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline-primary font-weight-bold px-2 py-1 flex-grow-1"
                                style={{ width: 'auto', fontSize: '0.72rem', borderRadius: '6px' }}
                                onClick={this.selectAllQuestions}
                            >
                                <i className="fas fa-check-double ml-1"></i>
                                {t('Pages.Missions.SelectAllQuestions') || 'تحديد الكل'}
                            </button>
                            <button
                                type="button"
                                className="btn btn-xs btn-outline-secondary font-weight-bold px-2 py-1 flex-grow-1"
                                style={{ width: 'auto', fontSize: '0.72rem', borderRadius: '6px' }}
                                onClick={this.deselectAllQuestions}
                            >
                                <i className="fas fa-times ml-1"></i>
                                {t('Pages.Missions.DeselectAllQuestions') || 'إلغاء التحديد'}
                            </button>
                        </div>

                        {/* Skills Tree Matching LessonItem Structure */}
                        <div style={{ maxHeight: '420px', overflowY: 'auto' }} className="pr-1">
                            {/* All Questions Root Node */}
                            <div
                                className={`skill-tree-item mb-2 rounded border ${focusedSkillId === 'ALL' ? 'active-focused' : ''}`}
                                onClick={() => this.setState({ focusedSkillId: 'ALL' })}
                            >
                                <div className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        className="ml-2"
                                        checked={isAllSelected}
                                        onChange={() => isAllSelected ? this.deselectAllQuestions() : this.selectAllQuestions()}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <span className="font-weight-bold text-dark small">
                                        <i className="fas fa-layer-group text-primary ml-1"></i>
                                        {t('Pages.Missions.AllQuestions') || 'كافة المهارات والأسئلة'}
                                    </span>
                                </div>
                                <span className="badge badge-light border text-muted" style={{ fontSize: '0.7rem' }}>
                                    {regularQuestions.length}
                                </span>
                            </div>

                            {/* 1. Main Domain Tree (Dimensions & Components) */}
                            {domainTree.map((domain) => {
                                const allDomainSkills = domain.components.flatMap(c => c.skills);
                                const allDomainQuestionIds = Array.from(new Set(allDomainSkills.flatMap(s => s.questions.map(q => q.Id))));
                                const domainSelectedCount = allDomainQuestionIds.filter(id => SelectedQuestions.includes(id)).length;
                                const isDomainAllSelected = allDomainQuestionIds.length > 0 && domainSelectedCount === allDomainQuestionIds.length;
                                const isDomainPartial = domainSelectedCount > 0 && domainSelectedCount < allDomainQuestionIds.length;
                                const isCollapsed = collapsedGroups[domain.id];

                                return (
                                    <div key={domain.id} className="domain-group-card shadow-2xs mb-2">
                                        {/* Domain Level Header with Select-All Checkbox */}
                                        <div
                                            className="domain-group-header cursor-pointer"
                                            onClick={() => this.toggleGroupCollapse(domain.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="ml-2"
                                                    checked={isDomainAllSelected}
                                                    onChange={() => this.toggleSelectGroupQuestions(allDomainSkills)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    title={`تحديد أو إلغاء تحديد كافة مهارات مجال: ${domain.name}`}
                                                />
                                                <i className="fas fa-folder-open text-warning ml-1" style={{ fontSize: '0.85rem' }}></i>
                                                <span className="font-weight-bold">{domain.name}</span>
                                            </div>

                                            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                {isDomainPartial && (
                                                    <i className="fas fa-minus-square text-warning" style={{ fontSize: '0.75rem' }} title="مختار جزئياً"></i>
                                                )}
                                                <span className="badge badge-secondary" style={{ fontSize: '0.68rem' }}>
                                                    {domainSelectedCount}/{allDomainQuestionIds.length}
                                                </span>
                                                <i className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'} text-muted`} style={{ fontSize: '0.7rem' }}></i>
                                            </div>
                                        </div>

                                        {/* Components & Skills List */}
                                        {!isCollapsed && (
                                            <div className="domain-group-skills-list">
                                                {domain.components.map((comp) => {
                                                    const compQuestionIds = Array.from(new Set(comp.skills.flatMap(s => s.questions.map(q => q.Id))));
                                                    const compSelectedCount = compQuestionIds.filter(id => SelectedQuestions.includes(id)).length;
                                                    const isCompAllSelected = compQuestionIds.length > 0 && compSelectedCount === compQuestionIds.length;

                                                    return (
                                                        <div key={comp.id} className="border-bottom pb-1 mb-1">
                                                            {/* Component Level Header */}
                                                            <div className="px-2 py-1 bg-light d-flex justify-content-between align-items-center">
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="ml-2"
                                                                        checked={isCompAllSelected}
                                                                        onChange={() => this.toggleSelectGroupQuestions(comp.skills)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        title={`تحديد كافة مهارات: ${comp.name}`}
                                                                    />
                                                                    <i className="fas fa-layer-group text-info ml-1" style={{ fontSize: '0.75rem' }}></i>
                                                                    <span className="small text-secondary font-weight-bold">{comp.name}</span>
                                                                </div>
                                                                <span className="badge badge-light border text-muted" style={{ fontSize: '0.65rem' }}>
                                                                    {comp.skills.length} مهارة
                                                                </span>
                                                            </div>

                                                            {/* Skills Under Component */}
                                                            {comp.skills.map(skill => renderSkillNode(skill))}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}

                            {/* 2. Other Skills Tree (SubDomains) */}
                            {otherSkillsTree.map((domain) => {
                                const allOtherSkills = domain.subDomains.flatMap(s => s.skills);
                                const allOtherQuestionIds = Array.from(new Set(allOtherSkills.flatMap(s => s.questions.map(q => q.Id))));
                                const otherSelectedCount = allOtherQuestionIds.filter(id => SelectedQuestions.includes(id)).length;
                                const isOtherAllSelected = allOtherQuestionIds.length > 0 && otherSelectedCount === allOtherQuestionIds.length;
                                const isOtherPartial = otherSelectedCount > 0 && otherSelectedCount < allOtherQuestionIds.length;
                                const isCollapsed = collapsedGroups[domain.id];

                                return (
                                    <div key={domain.id} className="domain-group-card shadow-2xs mb-2">
                                        <div
                                            className="domain-group-header cursor-pointer"
                                            onClick={() => this.toggleGroupCollapse(domain.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="ml-2"
                                                    checked={isOtherAllSelected}
                                                    onChange={() => this.toggleSelectGroupQuestions(allOtherSkills)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    title={`تحديد أو إلغاء تحديد كافة مهارات: ${domain.name}`}
                                                />
                                                <i className="fas fa-folder text-warning ml-1" style={{ fontSize: '0.85rem' }}></i>
                                                <span className="font-weight-bold">{domain.name}</span>
                                            </div>

                                            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                {isOtherPartial && (
                                                    <i className="fas fa-minus-square text-warning" style={{ fontSize: '0.75rem' }} title="مختار جزئياً"></i>
                                                )}
                                                <span className="badge badge-secondary" style={{ fontSize: '0.68rem' }}>
                                                    {otherSelectedCount}/{allOtherQuestionIds.length}
                                                </span>
                                                <i className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'} text-muted`} style={{ fontSize: '0.7rem' }}></i>
                                            </div>
                                        </div>

                                        {!isCollapsed && (
                                            <div className="domain-group-skills-list">
                                                {domain.subDomains.map((sub) => {
                                                    const subQuestionIds = Array.from(new Set(sub.skills.flatMap(s => s.questions.map(q => q.Id))));
                                                    const isSubAllSelected = subQuestionIds.length > 0 && subQuestionIds.every(id => SelectedQuestions.includes(id));

                                                    return (
                                                        <div key={sub.id} className="border-bottom pb-1 mb-1">
                                                            <div className="px-2 py-1 bg-light d-flex justify-content-between align-items-center">
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="ml-2"
                                                                        checked={isSubAllSelected}
                                                                        onChange={() => this.toggleSelectGroupQuestions(sub.skills)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        title={`تحديد كافة مهارات: ${sub.name}`}
                                                                    />
                                                                    <i className="fas fa-folder-open text-info ml-1" style={{ fontSize: '0.75rem' }}></i>
                                                                    <span className="small text-secondary font-weight-bold">{sub.name}</span>
                                                                </div>
                                                                <span className="badge badge-light border text-muted" style={{ fontSize: '0.65rem' }}>
                                                                    {sub.skills.length} مهارة
                                                                </span>
                                                            </div>
                                                            {sub.skills.map(skill => renderSkillNode(skill))}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Left Column: قائمة الأسئلة الموجودة في النص */}
                    <div className="questions-main-content shadow-2xs">
                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 pb-2 border-bottom" style={{ gap: '8px' }}>
                            <div className="d-flex align-items-center">
                                <span className="font-weight-bold text-dark" style={{ fontSize: '0.88rem' }}>
                                    <i className="fas fa-list-check text-primary ml-1"></i>
                                    {t('Pages.Missions.QuestionsInTextTitle') || 'الأسئلة والأنشطة في النص'}
                                </span>
                                {focusedSkillName && (
                                    <span className="badge badge-primary font-weight-bold mr-2 px-2 py-1" style={{ fontSize: '0.74rem' }}>
                                        <i className="fas fa-filter ml-1"></i>
                                        {focusedSkillName}
                                        <i
                                            className="fas fa-times mr-1 cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.setState({ focusedSkillId: 'ALL' })}
                                            title="عرض كافة الأسئلة"
                                        ></i>
                                    </span>
                                )}
                            </div>

                            <span className="badge badge-primary px-3 py-1 font-weight-bold" style={{ borderRadius: '12px', fontSize: '0.78rem' }}>
                                {filteredQuestions.length} {t('QuestionsCount') || 'سؤال متاح'}
                            </span>
                        </div>

                        {/* Search Input (Clean RTL Form Control) */}
                        <div className="position-relative mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('Pages.Missions.SearchQuestionsPlaceholder') || 'بحث في نص الأسئلة أو اسم المهارة...'}
                                value={searchQuery}
                                onChange={e => this.setState({ searchQuery: e.target.value })}
                                style={{
                                    fontSize: '0.84rem',
                                    paddingRight: '36px',
                                    paddingLeft: searchQuery ? '32px' : '12px',
                                    borderRadius: '10px',
                                    border: '1.5px solid #e2e8f0'
                                }}
                            />
                            <i
                                className="fas fa-search text-muted position-absolute"
                                style={{ right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem' }}
                            ></i>
                            {searchQuery && (
                                <i
                                    className="fas fa-times text-muted position-absolute cursor-pointer"
                                    style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem', cursor: 'pointer' }}
                                    onClick={() => this.setState({ searchQuery: '' })}
                                    title="مسح البحث"
                                ></i>
                            )}
                        </div>

                        {/* Scrollable Questions Content */}
                        <div className="questions-scrollable-list" style={{ maxHeight: '370px', overflowY: 'auto' }}>
                            {filteredQuestions.length === 0 ? (
                                <div className="text-center py-5 text-muted">
                                    <i className="fas fa-search-minus fa-2x mb-2 text-muted"></i>
                                    <div>{t('Pages.Missions.NoQuestionsFound') || 'لا توجد أسئلة تطابق المهارة أو البحث المحدد.'}</div>
                                </div>
                            ) : (
                                filteredQuestions.map((question, index) => {
                                    const isSelected = SelectedQuestions.includes(question.Id);
                                    const qSkills = this.getQuestionSkills(question);

                                    return (
                                        <div
                                            key={`question-card-${question.Id}`}
                                            className={`question-select-card ${isSelected ? 'selected' : ''}`}
                                        >
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div className="d-flex align-items-start flex-grow-1 ml-2">
                                                    {/* Checkbox */}
                                                    <input
                                                        type="checkbox"
                                                        className="mt-1 ml-2"
                                                        checked={isSelected}
                                                        onChange={() => isSelected ? this.DeselectQuestion(question.Id) : this.SelectQuestion(question.Id)}
                                                        id={`question_chk_${question.Id}`}
                                                    />

                                                    <div className="flex-grow-1 pr-1">
                                                        {/* Question Number & Content */}
                                                        <label
                                                            className="d-flex flex-wrap align-items-center mb-1 cursor-pointer"
                                                            htmlFor={`question_chk_${question.Id}`}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <span className="badge badge-primary px-2 py-1 ml-2 font-weight-bold" style={{ fontSize: '0.75rem', borderRadius: '6px' }}>
                                                                {index + 1}
                                                            </span>
                                                            <div className="text-dark font-weight-bold" style={{ fontSize: '0.88rem' }}>
                                                                {question.Type?.Id === 11
                                                                    ? (t('Pages.Lessons.Questions.type.Text') || 'نص إنشائي / تعبير')
                                                                    : <span dangerouslySetInnerHTML={{ __html: question.Name }}></span>
                                                                }
                                                            </div>
                                                        </label>

                                                        {/* Meta Row: Question Type, Mark, and Targeted Skill */}
                                                        <div className="d-flex flex-wrap align-items-center mt-2 pt-2 border-top" style={{ gap: '8px', fontSize: '0.75rem' }}>
                                                            {question.Type?.Name && (
                                                                <span className="badge badge-light border text-secondary px-2 py-1" style={{ borderRadius: '6px' }}>
                                                                    <i className="fas fa-tag ml-1"></i>
                                                                    {question.Type.Name}
                                                                </span>
                                                            )}

                                                            {question.Mark != null && (
                                                                <span className="badge badge-light border text-success px-2 py-1 font-weight-bold" style={{ borderRadius: '6px' }}>
                                                                    <i className="fas fa-star ml-1 text-warning"></i>
                                                                    {t('Pages.Missions.QuestionMark') || 'العلامة'}: {question.Mark}
                                                                </span>
                                                            )}

                                                            {/* Question Skill(s) Badge Under the Question */}
                                                            {qSkills.length > 0 ? (
                                                                qSkills.map((sk, sIdx) => (
                                                                    <span
                                                                        key={`q-${question.Id}-sk-${sk.id || sIdx}`}
                                                                        className="badge badge-light border text-primary font-weight-bold px-2 py-1"
                                                                        style={{ borderRadius: '6px', backgroundColor: '#eff6ff', borderColor: '#bfdbfe' }}
                                                                        title={`المهارة المستهدفة: ${sk.name}`}
                                                                    >
                                                                        <i className="fas fa-bullseye-arrow text-primary ml-1"></i>
                                                                        <span>{t('Pages.Missions.QuestionSkill') || 'المهارة'}: <strong>{sk.name}</strong></span>
                                                                        {sk.domain && <span className="text-muted mr-1">({sk.domain})</span>}
                                                                    </span>
                                                                ))
                                                            ) : (
                                                                <span className="badge badge-light border text-muted px-2 py-1" style={{ borderRadius: '6px' }}>
                                                                    <i className="fas fa-bullseye ml-1"></i>
                                                                    {t('Pages.Missions.GeneralSkill') || 'مهارة عامة للدرس'}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Button to Preview Question */}
                                                <div className="d-flex align-items-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-info px-2 py-1 font-weight-bold"
                                                        style={{ width: 'auto', borderRadius: '6px', fontSize: '0.74rem' }}
                                                        onClick={() => this.showQuestionModal(question, index + 1)}
                                                        title={t('Pages.Lessons.Questions.forms.View') || 'معاينة السؤال'}
                                                    >
                                                        <i className="fal fa-eye ml-1"></i>
                                                        {t('Pages.Lessons.Questions.forms.View') || 'معاينة'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>

                {/* Preview Modals */}
                {this.state.showQuestionModal && (
                    <ShowQuestionModal
                        renderQuestionView={this.renderQuestionView}
                        showResult={true}
                        handleClose={this.handleClose}
                    />
                )}

                {this.state.showInfoPageModal && (
                    <Modal
                        key="ModalQuestionView"
                        centered
                        size="xl"
                        show={true}
                        onHide={this.handleClose}
                        backdrop="static"
                        keyboard={false}
                        enforceFocus={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <i className="icon fal fa-info ml-2"></i>
                                {t('Pages.Lessons.info') || 'معلومات النص الإرشادي'}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="w-100 position-relative">
                                <div className="overlayer-question"></div>
                                {this.renderInfoPageQuestionView()}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                className="btn btn-danger font-weight-bold px-3 py-1"
                                style={{ width: 'auto', borderRadius: '8px' }}
                                onClick={this.handleClose}
                            >
                                <i className="fas fa-times ml-1"></i>
                                {t('Close') || 'إغلاق'}
                            </button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        lessonQuestions: state.lessonQuestions
    };
};

export default connect(mapStateToProps, { fetchLessonQuestions })(withTranslation('common')(LessonQuestionsList));